import { useRouter } from 'next/router';

const parseMap = {
  string: (value: string) => value,
  int: (value: string) => parseInt(value, 10),
  boolean: (value: string) => value === 'true',
};
type ParseType = keyof typeof parseMap;
type ParseMapReturnType<TKey extends ParseType> = ReturnType<
  (typeof parseMap)[TKey]
>;

export const useParam = <TParseType extends ParseType>(
  key: string,
  type: TParseType,
  { isOptional = false }: { isOptional?: boolean } = {}
): ParseMapReturnType<TParseType> => {
  const { query, isReady } = useRouter();

  if (!isReady && !isOptional)
    throw new Error(
      'Either wait for mount or ssr the view to be immediately ready'
    );

  const value = query[key];
  if (!value && !isOptional) throw new Error(`Param ${key} not found`);

  const parse = parseMap[type];
  const parsedValue = parse(value as string);
  return parsedValue as ParseMapReturnType<TParseType>;
};
